import { BadgeUserStatus, LabelInfo, SectionForm, TextDateFormat, TextIDCardFormat, TextTelFormat } from '../../components/shared'
import { Flex } from '@chakra-ui/react'

const ProfileDetail = ({ data, short = false }) => {
    return (
        <Flex w="full" align="start" direction="column">
            <SectionForm header="ขัอมูลบัญชี">
                <LabelInfo title="ชื่อบัญชี">{data.username}</LabelInfo>
                <LabelInfo title="สิทธิ์">{data.role_name}</LabelInfo>
                <LabelInfo title="สถานะ"><BadgeUserStatus status={data.status} /></LabelInfo>
                <LabelInfo title="วันที่สร้างบัญชี"><TextDateFormat value={data.created_at} full={true} /></LabelInfo>
            </SectionForm>
            <SectionForm header="ข้อมูลส่วนตัว" collapse={short}>
                <LabelInfo title="ชื่อ-นามสกุล">{data.full_name}</LabelInfo>
                <LabelInfo title="เลขบัตรประชาชน"><TextIDCardFormat value={data.id_card} /></LabelInfo>
                <LabelInfo title="อีเมล">{data.email}</LabelInfo>
                <LabelInfo title="โทร."><TextTelFormat value={data.tel} /></LabelInfo>
            </SectionForm>
            <SectionForm header="ตำแหน่งและหน่วยงาน" divider={false} collapse={short}>
                <LabelInfo title="ตำแหน่ง">{data.position}</LabelInfo>
                <LabelInfo title="ระดับ">{data.level_name}</LabelInfo>
                <LabelInfo title="หน่วยงาน">{data.office_name}</LabelInfo>
            </SectionForm>
        </Flex>
    )
}
export default ProfileDetail